export default "__VITE_ASSET__84d007c2__"